import { PersonalManager } from '@my-account/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

export const getPersonalManagerConfirmation: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.LoaderState<PersonalManager>
> = createSelector(getMyAccountState, (state: MyAccountState) => state.personalManagerConfirmation);

export const getPersonalManagerConfirmationSuccess: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getPersonalManagerConfirmation,
  (state) => StateUtils.loaderSuccessSelector(state),
);

export const getPersonalManagerConfirmationError: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getPersonalManagerConfirmation,
  (state) => StateUtils.loaderErrorSelector(state),
);

export const getPersonalManagerConfirmationValue: MemoizedSelector<StateWithMyAccount, PersonalManager> =
  createSelector(getPersonalManagerConfirmation, (state) => StateUtils.loaderValueSelector(state));
